import { View, Heading, Flex, TextField, ActionButton } from '@adobe/react-spectrum';
import { Delete } from '@mui/icons-material';
import { AddOnType } from '../../types';

const AddOnsList: React.FC<{ setAddons: React.Dispatch<React.SetStateAction<AddOnType[]>>; addons: AddOnType[] }> = ({ setAddons, addons }) => {
  const handleDelete = (idx: number) => {
    setAddons((prev) => prev.filter((_, index) => index !== idx));
  };

  const handleAddOnsInput = (key: string, value: string, index: number) => {
    const updatedValue = addons.map((item, idx) => {
      if (idx === index) {
        return {
          ...item,
          [key]: value,
        };
      }
      return item;
    });
    setAddons(updatedValue);
  };
  return (
    <View marginTop={'size-100'}>
      <Heading margin={0} level={4}>
        Addons List
      </Heading>
      {addons.map((item, idx) => {
        return (
          <Flex gap={'size-200'} width={'100%'} justifyContent={'center'}>
            <TextField width={'40%'} label="Title" value={item.title} onChange={(value) => handleAddOnsInput('title', value, idx)} />
            <TextField
              width={'40%'}
              label="Amount"
              value={item.amount}
              onChange={(value) => {
                const numericValue = value.replace(/\D/g, '').slice(0, 12);
                handleAddOnsInput('amount', numericValue, idx);
              }}
            />
            <ActionButton isQuiet marginTop={'size-300'} onPress={() => handleDelete(idx)}>
              <Delete />
            </ActionButton>
          </Flex>
        );
      })}
    </View>
  );
};

export default AddOnsList;
